module.exports = __webpack_public_path__ + "img/tradebg.0a11e7d2.jpg";